/* ══════════════════════════════════════════════
   MOCK DATA — Logistica Erogatori (Provider Tracker)
   ══════════════════════════════════════════════ */

export const mockProviders = [
  {
    id: 'prov-1',
    nome: 'Coop. Sanitas',
    tipo: 'Cooperativa Sociale',
    zona: 'Distretto Roma 2',
    tassoAccettazione: 92,
    rifiuti: 5,
    rifiutiPerc: 8,
    tempoMedioSLA: '1h 45m',
    frequenzaScelta: 24,
    indiceReclami: 0,
    contratto: 'Attivo — Scad. 12/2026',
    specialita: ['Riabilitazione', 'Infermieristica'],
  },
  {
    id: 'prov-2',
    nome: 'Assistenza Domani Srl',
    tipo: 'Impresa Sociale',
    zona: 'Roma Sud',
    tassoAccettazione: 88,
    rifiuti: 9,
    rifiutiPerc: 12,
    tempoMedioSLA: '2h 10m',
    frequenzaScelta: 18,
    indiceReclami: 2,
    contratto: 'Attivo — Scad. 06/2026',
    specialita: ['Cure Palliative', 'OSS'],
  },
  {
    id: 'prov-3',
    nome: 'CasaCura Plus',
    tipo: 'Cooperativa Sociale',
    zona: 'Distretto Roma 1',
    tassoAccettazione: 85,
    rifiuti: 12,
    rifiutiPerc: 15,
    tempoMedioSLA: '3h 05m',
    frequenzaScelta: 15,
    indiceReclami: 1,
    contratto: 'Attivo — Scad. 09/2026',
    specialita: ['Infermieristica Avanzata'],
  },
  {
    id: 'prov-4',
    nome: 'ServiziSalute Coop',
    tipo: 'Cooperativa',
    zona: 'Roma Est',
    tassoAccettazione: 78,
    rifiuti: 18,
    rifiutiPerc: 22,
    tempoMedioSLA: '4h 30m',
    frequenzaScelta: 9,
    indiceReclami: 4,
    contratto: 'In revisione',
    specialita: ['Assistenza Base'],
  },
  {
    id: 'prov-5',
    nome: 'Progetto Domicilio',
    tipo: 'Associazione',
    zona: 'Distretto Roma 3',
    tassoAccettazione: 95,
    rifiuti: 2,
    rifiutiPerc: 3,
    tempoMedioSLA: '1h 15m',
    frequenzaScelta: 31,
    indiceReclami: 0,
    contratto: 'Attivo — Scad. 03/2027',
    specialita: ['Polispecialistica', 'Fisioterapia'],
  },
  {
    id: 'prov-6',
    nome: 'Salus Domiciliare',
    tipo: 'Srl',
    zona: 'Roma Nord',
    tassoAccettazione: 72,
    rifiuti: 22,
    rifiutiPerc: 28,
    tempoMedioSLA: '5h 20m',
    frequenzaScelta: 6,
    indiceReclami: 6,
    contratto: 'Sotto osservazione',
    specialita: ['OSS', 'Assistenza Base'],
  },
];

export const mockProviderLogs = {
  'prov-1': [
    { id: 'PAZ-1029', dataInvio: '18/02/2026 09:15', origine: 'Job Rotation', esito: 'Accettato', tempoRisposta: '1h 12m', causaleRifiuto: '-', complessita: 'Alta' },
    { id: 'PAZ-1034', dataInvio: '17/02/2026 14:30', origine: 'Preferenza Paziente', esito: 'Accettato', tempoRisposta: '0h 45m', causaleRifiuto: '-', complessita: 'Media' },
    { id: 'PAZ-1041', dataInvio: '15/02/2026 11:00', origine: 'Broadcast', esito: 'Accettato', tempoRisposta: '2h 05m', causaleRifiuto: '-', complessita: 'Bassa' },
    { id: 'PAZ-1052', dataInvio: '12/02/2026 08:45', origine: 'Job Rotation', esito: 'Rifiutato', tempoRisposta: '3h 30m', causaleRifiuto: 'Operatori non disponibili nella zona indicata', complessita: 'Alta' },
    { id: 'PAZ-1058', dataInvio: '10/02/2026 16:20', origine: 'Preferenza Paziente', esito: 'Accettato', tempoRisposta: '1h 50m', causaleRifiuto: '-', complessita: 'Media' },
    { id: 'PAZ-1063', dataInvio: '08/02/2026 10:10', origine: 'Broadcast', esito: 'Scaduto', tempoRisposta: '24h 00m', causaleRifiuto: 'Timeout — nessuna risposta', complessita: 'Bassa' },
    { id: 'PAZ-1070', dataInvio: '05/02/2026 13:40', origine: 'Job Rotation', esito: 'Accettato', tempoRisposta: '1h 20m', causaleRifiuto: '-', complessita: 'Alta' },
    { id: 'PAZ-1075', dataInvio: '03/02/2026 09:00', origine: 'Preferenza Paziente', esito: 'Accettato', tempoRisposta: '0h 30m', causaleRifiuto: '-', complessita: 'Media' },
  ],
  'prov-2': [
    { id: 'PAZ-1030', dataInvio: '18/02/2026 10:00', origine: 'Preferenza Paziente', esito: 'Ricevuto', tempoRisposta: '-', causaleRifiuto: '-', complessita: 'Media' },
    { id: 'PAZ-1037', dataInvio: '16/02/2026 08:30', origine: 'Broadcast', esito: 'Accettato', tempoRisposta: '2h 40m', causaleRifiuto: '-', complessita: 'Bassa' },
    { id: 'PAZ-1043', dataInvio: '14/02/2026 15:15', origine: 'Job Rotation', esito: 'Rifiutato', tempoRisposta: '4h 10m', causaleRifiuto: 'Incompatibilita con specializzazione richiesta', complessita: 'Alta' },
    { id: 'PAZ-1049', dataInvio: '11/02/2026 11:50', origine: 'Preferenza Paziente', esito: 'Accettato', tempoRisposta: '1h 55m', causaleRifiuto: '-', complessita: 'Media' },
    { id: 'PAZ-1055', dataInvio: '09/02/2026 09:20', origine: 'Broadcast', esito: 'Rifiutato', tempoRisposta: '6h 00m', causaleRifiuto: 'Capienza massima raggiunta', complessita: 'Alta' },
    { id: 'PAZ-1061', dataInvio: '06/02/2026 14:00', origine: 'Job Rotation', esito: 'Accettato', tempoRisposta: '2h 15m', causaleRifiuto: '-', complessita: 'Bassa' },
  ],
  'prov-3': [
    { id: 'PAZ-1031', dataInvio: '18/02/2026 08:00', origine: 'Job Rotation', esito: 'Accettato', tempoRisposta: '3h 00m', causaleRifiuto: '-', complessita: 'Alta' },
    { id: 'PAZ-1038', dataInvio: '16/02/2026 12:45', origine: 'Broadcast', esito: 'Scaduto', tempoRisposta: '24h 00m', causaleRifiuto: 'Timeout — nessuna risposta', complessita: 'Media' },
    { id: 'PAZ-1044', dataInvio: '13/02/2026 10:30', origine: 'Preferenza Paziente', esito: 'Rifiutato', tempoRisposta: '5h 20m', causaleRifiuto: 'Zona non coperta dal servizio', complessita: 'Alta' },
    { id: 'PAZ-1050', dataInvio: '11/02/2026 16:00', origine: 'Job Rotation', esito: 'Accettato', tempoRisposta: '2h 45m', causaleRifiuto: '-', complessita: 'Bassa' },
    { id: 'PAZ-1056', dataInvio: '08/02/2026 09:15', origine: 'Broadcast', esito: 'Rifiutato', tempoRisposta: '8h 10m', causaleRifiuto: 'Personale insufficiente per il turno serale', complessita: 'Media' },
  ],
  'prov-4': [
    { id: 'PAZ-1032', dataInvio: '17/02/2026 11:30', origine: 'Broadcast', esito: 'Rifiutato', tempoRisposta: '6h 45m', causaleRifiuto: 'Capienza massima raggiunta', complessita: 'Alta' },
    { id: 'PAZ-1039', dataInvio: '15/02/2026 09:00', origine: 'Job Rotation', esito: 'Accettato', tempoRisposta: '4h 20m', causaleRifiuto: '-', complessita: 'Bassa' },
    { id: 'PAZ-1045', dataInvio: '13/02/2026 14:20', origine: 'Broadcast', esito: 'Scaduto', tempoRisposta: '24h 00m', causaleRifiuto: 'Timeout — nessuna risposta', complessita: 'Media' },
    { id: 'PAZ-1051', dataInvio: '10/02/2026 08:00', origine: 'Preferenza Paziente', esito: 'Rifiutato', tempoRisposta: '3h 50m', causaleRifiuto: 'Assenza operatore con qualifica richiesta', complessita: 'Alta' },
    { id: 'PAZ-1057', dataInvio: '07/02/2026 15:30', origine: 'Job Rotation', esito: 'Accettato', tempoRisposta: '5h 10m', causaleRifiuto: '-', complessita: 'Bassa' },
    { id: 'PAZ-1062', dataInvio: '05/02/2026 10:40', origine: 'Broadcast', esito: 'Rifiutato', tempoRisposta: '7h 30m', causaleRifiuto: 'Turni gia coperti al 100%', complessita: 'Media' },
  ],
  'prov-5': [
    { id: 'PAZ-1033', dataInvio: '18/02/2026 07:30', origine: 'Preferenza Paziente', esito: 'Accettato', tempoRisposta: '0h 55m', causaleRifiuto: '-', complessita: 'Media' },
    { id: 'PAZ-1040', dataInvio: '16/02/2026 10:15', origine: 'Job Rotation', esito: 'Accettato', tempoRisposta: '1h 10m', causaleRifiuto: '-', complessita: 'Alta' },
    { id: 'PAZ-1046', dataInvio: '14/02/2026 13:00', origine: 'Broadcast', esito: 'Accettato', tempoRisposta: '1h 30m', causaleRifiuto: '-', complessita: 'Bassa' },
    { id: 'PAZ-1053', dataInvio: '12/02/2026 09:45', origine: 'Preferenza Paziente', esito: 'Accettato', tempoRisposta: '0h 40m', causaleRifiuto: '-', complessita: 'Media' },
    { id: 'PAZ-1059', dataInvio: '09/02/2026 16:30', origine: 'Job Rotation', esito: 'Rifiutato', tempoRisposta: '2h 00m', causaleRifiuto: 'Conflitto orario con altro paziente', complessita: 'Alta' },
    { id: 'PAZ-1064', dataInvio: '06/02/2026 08:20', origine: 'Broadcast', esito: 'Accettato', tempoRisposta: '1h 05m', causaleRifiuto: '-', complessita: 'Bassa' },
    { id: 'PAZ-1068', dataInvio: '04/02/2026 11:15', origine: 'Preferenza Paziente', esito: 'Accettato', tempoRisposta: '0h 35m', causaleRifiuto: '-', complessita: 'Media' },
  ],
  'prov-6': [
    { id: 'PAZ-1035', dataInvio: '17/02/2026 13:00', origine: 'Broadcast', esito: 'Rifiutato', tempoRisposta: '8h 00m', causaleRifiuto: 'Assenza operatore con qualifica richiesta', complessita: 'Alta' },
    { id: 'PAZ-1042', dataInvio: '15/02/2026 10:30', origine: 'Job Rotation', esito: 'Scaduto', tempoRisposta: '24h 00m', causaleRifiuto: 'Timeout — nessuna risposta', complessita: 'Media' },
    { id: 'PAZ-1048', dataInvio: '13/02/2026 08:45', origine: 'Broadcast', esito: 'Rifiutato', tempoRisposta: '5h 45m', causaleRifiuto: 'Zona non coperta dal servizio', complessita: 'Alta' },
    { id: 'PAZ-1054', dataInvio: '10/02/2026 14:10', origine: 'Preferenza Paziente', esito: 'Accettato', tempoRisposta: '6h 20m', causaleRifiuto: '-', complessita: 'Bassa' },
    { id: 'PAZ-1060', dataInvio: '08/02/2026 11:00', origine: 'Broadcast', esito: 'Rifiutato', tempoRisposta: '4h 50m', causaleRifiuto: 'Capienza massima raggiunta', complessita: 'Media' },
  ],
};

export const mockProviderAudit = {
  'prov-1': { reclami: [], segnalazioni: [] },
  'prov-2': {
    reclami: [
      { id: 'REC-201', data: '14/02/2026', paziente: 'Bianchi G.', testo: 'Ritardo sistematico dell\'operatore OSS nelle fasce mattutine (7:30-8:30). Segnalato 3 volte.' },
      { id: 'REC-202', data: '09/02/2026', paziente: 'Marchetti T.', testo: 'Comunicazione insufficiente: il caregiver non viene informato dei cambi turno.' },
    ],
    segnalazioni: [
      { id: 'SEG-301', data: '16/02/2026', paziente: 'Esposito L.', tipo: 'Richiesta cambio ente', motivo: 'Insoddisfazione per la qualita del servizio fisioterapico.' },
    ],
  },
  'prov-3': {
    reclami: [
      { id: 'REC-203', data: '11/02/2026', paziente: 'Verdi A.', testo: 'Mancata erogazione di 2 accessi infermieristici nella settimana 6-12 Febbraio senza preavviso.' },
    ],
    segnalazioni: [],
  },
  'prov-4': {
    reclami: [
      { id: 'REC-204', data: '15/02/2026', paziente: 'Ferrara E.', testo: 'Operatore OSS non qualificato per gestione CVC. Richiesta sostituzione immediata.' },
      { id: 'REC-205', data: '12/02/2026', paziente: 'Rossi M.', testo: 'Igiene personale eseguita in modo frettoloso e superficiale. Lamentela del caregiver.' },
      { id: 'REC-206', data: '07/02/2026', paziente: 'De Luca C.', testo: 'Ritardo di 3 ore sull\'accesso programmato del 07/02. Nessuna comunicazione preventiva.' },
    ],
    segnalazioni: [
      { id: 'SEG-302', data: '13/02/2026', paziente: 'Ferrara E.', tipo: 'Richiesta cambio ente', motivo: 'Inadeguatezza professionale segnalata dal medico curante.' },
      { id: 'SEG-303', data: '10/02/2026', paziente: 'Rossi M.', tipo: 'Richiesta cambio ente', motivo: 'Reiterati ritardi e scarsa empatia dell\'operatore assegnato.' },
    ],
  },
  'prov-5': { reclami: [], segnalazioni: [] },
  'prov-6': {
    reclami: [
      { id: 'REC-207', data: '16/02/2026', paziente: 'Lombardi E.', testo: 'Mancata somministrazione farmaco per dimenticanza operatore. Evento avverso segnalato.' },
      { id: 'REC-208', data: '13/02/2026', paziente: 'Galli F.', testo: 'Operatore non si e presentato all\'accesso del 13/02. Nessuna giustificazione fornita.' },
      { id: 'REC-209', data: '10/02/2026', paziente: 'Conti S.', testo: 'Comportamento scortese dell\'operatore nei confronti del caregiver familiare.' },
      { id: 'REC-210', data: '06/02/2026', paziente: 'Neri P.', testo: 'Documentazione clinica compilata in modo incompleto e illeggibile.' },
    ],
    segnalazioni: [
      { id: 'SEG-304', data: '15/02/2026', paziente: 'Lombardi E.', tipo: 'Richiesta cambio ente', motivo: 'Evento avverso farmacologico. Famiglia richiede cambio immediato.' },
      { id: 'SEG-305', data: '11/02/2026', paziente: 'Galli F.', tipo: 'Richiesta cambio ente', motivo: 'Accessi mancati ripetuti. Paziente fragile rimasto senza assistenza.' },
      { id: 'SEG-306', data: '08/02/2026', paziente: 'Conti S.', tipo: 'Richiesta cambio ente', motivo: 'Conflitto relazionale irrisolvibile con l\'operatore assegnato.' },
    ],
  },
};
